import Api from "lib/api";

import { toast } from "react-toastify";

const api = Api.getInstance();

const ns = "app/forgot-password/";

export const REQUEST_START = ns + "REQUEST_START";
export const REQUEST_SUCCESS = ns + "REQUEST_SUCCESS";
export const REQUEST_FAILURE = ns + "REQUEST_FAILURE";

export function request (data, history) {
    return async (dispatch) => {
        dispatch({
            type: REQUEST_START
        });

        try {
            const response = await api.post('users/request-password-reset', data);

            dispatch({
                type: REQUEST_SUCCESS
            });

            if (response.data.sent) {
                toast.success('Check your email for a password reset link!');
            } else {
                toast.error('There was an error sending a reset link. Try again later.');
            }

            history.push('/');

        } catch (error) {
            toast.error('Unable to reset password: ' + error.response.data.message);

            dispatch({
                type: REQUEST_FAILURE,
                payload: error.response.data
            });
        }
    };
};


// WEBPACK FOOTER //
// ./src/components/app/forgot-password/actions.js